export interface UmpireProductCategory {
  id: string;

  type: 'category';

  name: string | null;
}
